var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "../../UI";

const normalizeIndex = (index, length) => index >= 0 ? index % length : length + index;

const getVisibleIndices = (centerIndex, visibleCount, totalLength) => {
  const minIndex = -Math.floor(visibleCount / 2);
  const rawIndices = [];
  for (let i = 0; i < visibleCount; i += 1) {
    rawIndices.push(centerIndex + minIndex + i);
  }
  return rawIndices.map((i) => normalizeIndex(i, totalLength));
};

const getVisibleItems = (data, currentIndex, visibleCount) => {
  if (!data.length) {
    return [];
  }

  let visibleIndices = data.map((_item, index) => index);

  if (data.length > visibleCount) {
    visibleIndices = getVisibleIndices(currentIndex, visibleCount, data.length);
  }

  const visibleItems = visibleIndices.map((i) => data[i]);
  return visibleItems;
};

export default class VictimSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // initialize slider with a victim that has an image
      currentIndex: 0
    };
  }

  componentDidMount() {
    const { initialIndex } = this.props;
    this.setState({
      currentIndex: initialIndex || 0
    });
  }

  slide(dir) {
    let { currentIndex } = this.state;
    const { children } = this.props;
    currentIndex = normalizeIndex(currentIndex + dir, children.length);
    this.setState({ currentIndex });
  }

  render() {
    const { children, visibleCount } = this.props;
    const { currentIndex } = this.state;
    const items = getVisibleItems(children, currentIndex, visibleCount);

    return (/*#__PURE__*/
      _jsx("div", { className: "slider" }, void 0,
      children.length > visibleCount && /*#__PURE__*/
      _jsx("div", { className: "slider-buttons" }, void 0, /*#__PURE__*/
      _jsx("button", { className: "slider-btn", onClick: () => this.slide(-1) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "angle-left" })
      ), /*#__PURE__*/
      _jsx("button", { className: "slider-btn", onClick: () => this.slide(1) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "angle-right" })
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "slider-items" }, void 0, items)
      ));

  }
}